import React from 'react';

function Backgroundscreen() {
  return (
  <div className='backgroundscreen'>
  </div>
  );
}

export default Backgroundscreen;
